'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _helpers = require('./helpers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PubSub = function () {
    function PubSub() {
        _classCallCheck(this, PubSub);

        this.messages = {};
        this.lastToken = -1;
    }

    _createClass(PubSub, [{
        key: 'subscribe',
        value: function subscribe(message, func) {
            if (typeof func !== 'function') {
                return false;
            }

            if (!this.messages.hasOwnProperty(message)) {
                this.messages[message] = {};
            }

            var token = 'token_' + String(++this.lastToken);
            this.messages[message][token] = func;

            return token;
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe(value) {
            var isToken = !this.messages.hasOwnProperty(value) && typeof value === 'string';
            var isFunction = typeof value === 'function';
            var result = false;
            var m = void 0;
            var t = void 0;
            var message = void 0;

            for (m in this.messages) {
                if (this.messages.hasOwnProperty(m)) {
                    message = this.messages[m];

                    if (isToken && message[value]) {
                        delete message[value];
                        result = value;
                        break;
                    }

                    if (isFunction) {
                        for (t in message) {
                            if (message.hasOwnProperty(t) && message[t] === value) {
                                delete message[t];
                                result = true;
                            }
                        }
                    }
                }
            }

            return result;
        }
    }, {
        key: 'publish',
        value: function publish(message, data) {
            var hasSubscribers = this.messageHasSubscribers(message);

            if (!hasSubscribers) {
                return false;
            }

            var subscriber = this.messages[message];
            var s = void 0;

            for (s in subscriber) {
                if (subscriber.hasOwnProperty(s)) {
                    subscriber[s](message, data);
                }
            }

            return true;
        }
    }, {
        key: 'messageHasSubscribers',
        value: function messageHasSubscribers(message) {
            return (0, _helpers.hasKeys)(this.messages[message]);
        }
    }]);

    return PubSub;
}();

exports.default = PubSub;


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-kenny-loggins/lib/PubSub.js
// module id = 755
// module chunks = 0